import moment from 'moment'
import { stringFunctionHelpers } from './stringHelpers'
const _ = require('lodash')

/**
 * Da formato a una fecha de tipo yyyy/mm/dd -> dd/mm/yyyy o viceversa
 * @param {string} date
 * @returns
 */
const inverseFormat = (date) => {
  if (isValidDate(date)) {
    const dateSplited = date.split('/')
    return `${dateSplited[2]}/${dateSplited[1]}/${dateSplited[0]}`
  }
  return null
}

/** //esta funcion no deberia usarse ya que no sirve correctamente pero algunas repos aun lo tienen
 * Formatea una fecha typo Date
 * @param {*} date
 * @param {*} format
 * @returns
 */
const formatDate = (date, format = 'DD/MM/YYYY') => {
  try {
    const result = moment(date).format(format)
    return result && result !== 'Invalid date' ? result : null
  } catch (error) {
    return null
  }
}

/**
 * Formatea una fecha tipo string
 * @param {*} date
 * @param {*} format
 * @returns
 */
 const formatDateString = (date, format = 'DD/MM/YYYY') => {
  try {
    if (_.isDate(date)) {
      return moment(date).format(format)
    }
    date = stringFunctionHelpers.replaceAll(date, '/', '-')
    var formats = [
      'YYYY-MM-DD',
      'DD-MM-YYYY',
      'YYYY-MM-DDTHH:mm:ss.ssssssZ',
      'YYYY-MM-DD HH:mm:ss.ssssss',
      'YYYY-MM-DDTHH:mm:ss.sssZ',
      'YYYY-MM-DD HH:mm:ss.sss',
      'DD-MM-YYYYTHH:mm:ss.ssssssZ',
      'DD-MM-YYYY HH:mm:ss.ssssss',
      'DD-MM-YYYYTHH:mm:ss.sssZ',
      'DD-MM-YYYY HH:mm:ss.sss',
      'YYYY-MM-DD HH:mm:ss',
      'DD-MM-YYYY HH:mm:ss'
    ]
    var dateFormat = ''
    formats.every((element) => {
      dateFormat = moment(date, element, true).format(format)
      return dateFormat === 'Invalid date'
    })

    return dateFormat && dateFormat !== 'Invalid date' ? dateFormat : null
  } catch (error) {
    return null
  }
}

/**
 * cambia la fecha al formato contrario
 * @param {*} date
 * @param {*} format
 * @returns
 */
const changeFormat = (date, delimiter = '/', resultDelimiter = null) => {
  try {
    if (date && delimiter) {
      const dateSplited = date.split(delimiter)
      return `${dateSplited[2]}${resultDelimiter ?? delimiter}${
        dateSplited[1]
      }${resultDelimiter ?? delimiter}${dateSplited[0]}`
    }
    return null
  } catch (error) {
    return null
  }
}

/**
 * Valida que la fecha sea correcta
 * @param {*} date
 * @returns
 */
const isValidDate = (date) => {
  try {
    const newDate = stringFunctionHelpers.replaceAll(date, '/', '-')
    var fecha = moment(newDate, 'YYYY-MM-DD', true)
    if (fecha.isValid()) return true
    else {
      fecha = moment(newDate, 'DD-MM-YYYY', true)
      return fecha.isValid()
    }
  } catch (error) {
    return false
  }
}

const isLower = (fechaInicio, fechaFinal) => {
  var fechaIni = formatDateString(fechaInicio, 'YYYY-MM-DD')
  var fechaFin = formatDateString(fechaFinal, 'YYYY-MM-DD')

  try {
    if (fechaIni !== 'Invalid date' && fechaFin !== 'Invalid date') {
      return fechaIni < fechaFin
    }
    return false
  } catch (error) {
    return false
  }
}

const isHigher = (fechaInicio, fechaFinal) => {
  var fechaIni = formatDateString(fechaInicio, 'YYYY-MM-DD')
  var fechaFin = formatDateString(fechaFinal, 'YYYY-MM-DD')
  try {
    if (fechaIni !== 'Invalid date' && fechaFin !== 'Invalid date') {
      return fechaIni > fechaFin
    }
    return false
  } catch (error) {
    return false
  }
}

const isTimeLower = (horaInicio, horaFinal) => {
  try {
    return (
      moment(horaInicio).format('HH:mm') < moment(horaFinal).format('HH:mm')
    )
  } catch (error) {
    return false
  }
}

const isTimeHigher = (horaInicio, horaFinal) => {
  try {
    return (
      moment(horaInicio).format('HH:mm') > moment(horaFinal).format('HH:mm')
    )
  } catch (error) {
    return false
  }
}

/**
 * Compara dos fechas, retorna true si son iguales
 * @param {*} date1
 * @param {*} date2
 * @returns
 */
const isSameDate = (date1, date2) => {
  var fecha1 = formatDateString(date1, 'YYYY-MM-DD')
  var fecha2 = formatDateString(date2, 'YYYY-MM-DD')
  try {
    if (fecha1 !== 'Invalid date' && fecha2 !== 'Invalid date') {
      return fecha1 == fecha2
    }
    return false
  } catch (error) {
    return false
  }
}

export const dateFunctionHelpers = {
  formatDate: formatDate,
  isValidDate: isValidDate,
  isSameDate: isSameDate,
  inverseFormat: inverseFormat,
  isLower: isLower,
  isHigher: isHigher,
  isTimeLower: isTimeLower,
  isTimeHigher: isTimeHigher,
  changeFormat: changeFormat,
  formatDateString: formatDateString
}
